import { getUser } from "./Api";
import { IContentCreator } from "./Interfaces";

export const PERMISSIONS = {
  dashboardView: "dashboard.view",
  usersView: "users.view",
  usersEdit: "users.edit",
  usersDelete: "users.delete",
  usersMessages: "users.messages",
  usersBetaFeatures: "users.beta-features",
  usersSendNotification: "users.send-notification",
  charactersView: "characters.view",
  charactersCreate: "characters.create",
  charactersEdit: "characters.edit",
  charactersDelete: "characters.delete",
  charactersDeleteOwn: "characters.delete-own",
  reportsView: "reports.view",
  paymentsView: "payments.view",
  wordsView: "words.view",
  wordCardsView: "word-cards.view",
  wordCardsCreate: "word-cards.create",
  wordCardsEdit: "word-cards.edit",
  wordCardsDelete: "word-cards.delete",
  wordCardsDeleteOwn: "word-cards.delete-own",
  notificationsView: "notifications.view",
  notificationsCreate: "notifications.create",
  surveysView: "surveys.view",
  surveysCreate: "surveys.create",
  surveysEdit: "surveys.edit",
  surveysDelete: "surveys.delete",
  chatLessonsView: "chat-lessons.view",
  chatLessonsCreate: "chat-lessons.create",
  chatLessonsEdit: "chat-lessons.edit",
  chatLessonsDelete: "chat-lessons.delete",
  chatLessonsDeleteOwn: "chat-lessons.delete-own",
  journeysView: "journeys.view",
  journeysCreate: "journeys.create",
  journeysEdit: "journeys.edit",
  journeysDelete: "journeys.delete",
  journeysDeleteOwn: "journeys.delete-own",
  journeysLogs: "journeys.logs",
  settingsView: "settings.view",
} as const;

export type Permission = string;

export function isAdmin(): boolean {
  return getUser()?.role !== "manager";
}

export function hasPermission(permission?: Permission): boolean {
  if (!permission) return true;
  const user = getUser();
  return user?.role !== "manager" || user?.permissions?.includes(permission);
}

export function canManageContentActivation(): boolean {
  return isAdmin();
}

export function canDeleteContent(
  creator: IContentCreator | undefined,
  generalPermission: Permission,
  ownPermission: Permission,
): boolean {
  if (isAdmin() || hasPermission(generalPermission)) return true;
  return (
    hasPermission(ownPermission) &&
    !!creator?.id &&
    creator.id === (getUser()?.id ?? getUser()?.adminID)
  );
}
